<template>
  <div>
    <!-- 列表 -->
    <ul v-if="showList.length" class="live-list-wrap" @scroll="handleScroll">
      <li class="live-item" v-for="item in showList" :key="item.lesson_id">
        <div class="time-axis">
          <p v-if="showAll" v-html="liveInThisYear(item)"></p>
          <span>{{ moment(item.live_start_time * 1000).format("HH:mm") }}</span>
        </div>
        <div class="live-card" @click="goLiveRoom(item)">
          <img
            class="cover"
            :src="item.cover_url + '?imageView2/0/w/320'"
            alt=""
          />
          <div class="live-info">
            <p class="name">
              {{ item.lesson_name }}
            </p>
            <p class="course-name">
              所属课程：<span>{{ item.course_name }}</span>
            </p>
            <p class="unit-name">
              所属单元：<span>{{ item.unit_name }}</span>
            </p>
          </div>
          <div class="operate-wrap">
            <!-- <button class="join-live-btn">进入教室</button> -->
            <button v-if="item.liveStatus === 1" class="text-btn status">
              观看视频
            </button>
            <button v-else-if="item.liveStatus === 3" class="join-live-btn">
              <img src="../../../../assets/images/living-white.gif" alt="" />
              {{ item.tips }}
            </button>
            <span
              v-else
              class="tips-text status"
              :class="{ red: item.liveStatus === 5 }"
              >{{ item.tips }}</span
            >
          </div>
        </div>
      </li>
    </ul>
    <el-empty
      v-else
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
  </div>
</template>

<script>
import moment from "moment";
import { checkLiveTime } from "@saas/server-api/src/teacher";
export default {
  props: {
    showAll: {
      type: Boolean,
      default: false,
    },
    showList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function () {
    return {
      moment,
    };
  },
  methods: {
    handleScroll(event) {
      this.$emit("handleScroll", event);
    },
    async goLiveRoom(item) {
      let res = await checkLiveTime();
      console.log("res___", res.data);
      if (res.code === 1 && res.data) {
        item.is_new_live = res.data.is_new_live;
      }
      console.log(item, "goLiveRoom-item");
      if (item.liveStatus === 1) {
        let { course_id, lesson_id, unit_id } = item;
        this.$router.push({
          path: `/video-play/${course_id}/${unit_id}/${lesson_id}`,
        });
      } else if (item.liveStatus === 3) {
        this.$emit("goLiveRoom", item);
      }
    },
  },
  computed: {
    liveInThisYear(item) {
      return (item) => {
        let { live_start_time } = item;
        let nowYear = new Date().getFullYear();
        let liveYear = new Date(live_start_time * 1000).getFullYear();
        if (nowYear === liveYear) {
          return `<span>${moment(item.live_start_time * 1000).format(
            "MM月DD日"
          )}</span>`;
        } else {
          let num = 14;
          if (window.isElectron) {
            num = 12;
          }
          return `<span style="font-size:${num}px">${moment(
            item.live_start_time * 1000
          ).format("YYYY.MM.DD")}</span>`;
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
